import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatStepperModule } from '@angular/material/stepper';
import { RouterModule } from '@angular/router';
import { ScGenericFormModule } from '../sc-generic-form/sc-generic-form.module';
import { ScWidgetModule } from '../sc-widget/sc-widget.module';
import { ScCanActivateStepService } from './sc-can-activate-step';
import { ScHorizontalStepperComponent } from './sc-horizontal-stepper/sc-horizontal-stepper.component';
import { ScStepService } from './sc-step.service';
import { ScStepFooterDirective, ScStepHeaderDirective, ScStepComponent } from './sc-step/sc-step.component';
import { ScTemplateService } from './sc-template.service';
import { ScVerticalStepperComponent } from './sc-vertical-stepper.component';

@NgModule({
  declarations: [ScVerticalStepperComponent, ScStepComponent, ScStepFooterDirective, ScStepHeaderDirective, ScHorizontalStepperComponent],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    MatIconModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    ScWidgetModule,
    ScGenericFormModule,
    MatStepperModule
  ],
  providers: [ScStepService, ScTemplateService, ScCanActivateStepService],
  exports: [ScVerticalStepperComponent, ScStepComponent, ScHorizontalStepperComponent]
})
export class VerticalStepperModule {}
